import script from "./ChatWindow.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatWindow.vue?vue&type=script&setup=true&lang=ts"

import "./ChatWindow.vue?vue&type=style&index=0&id=e54441e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e54441e4"]])

export default __exports__